import { render } from "./VerifyPhone.vue?vue&type=template&id=52ca2b47&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"

import "./VerifyPhone.vue?vue&type=style&index=0&id=52ca2b47&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ca2b47"]])

export default __exports__